import { Device } from './../home/home.model';
import { DeviceService } from './../../shared/services/device.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Options } from 'ng5-slider';
import { Brand } from 'src/app/includes/sidebar/sidebar.model';
import { BrandService } from 'src/app/shared/services/brand.service';
declare var $: any;
@Component({
    selector: 'app-product-list',
    templateUrl: './product-list.component.html',
    styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {
    brandName = '';
    getBy: string;
    devices: Device;
    brands: Brand;
    type: string;
    ads: string;
    constructor(
        private route: ActivatedRoute,
        private deviceService: DeviceService,
        private router: Router,
        private brandService: BrandService
    ) {
        this.route.params.subscribe(Response => {
            this.type = Response.type;
            this.ads = this.type;
            this.ads === 'phones' || this.ads === 'accessories' || this.ads === 'tablets' || this.ads === 'watches'
                ? ''
                : (this.ads = 'adsTop');
            this.brandName = Response.brand;
            !this.brandName ? (this.brandName = '') : '';

            this.router.routeReuseStrategy.shouldReuseRoute = function() {
                return false;
            };
        });
    }

    minValue: number;
    maxValue: number;
    page: number = 1;
    metadata = {
        limit: 0,
        offset: 0,
        total: 0
    };
    date: string = 'new';
    price: string = 'high';
    sortDatePrice: string = 'new';
    filterValue: string;
    options: Options = {
        floor: 0,
        ceil: 2000,
        translate: (value: number): string => {
            return '$' + value;
        }
    };

    ngOnInit() {
        // reset
        this.minValue = 0;
        this.maxValue = 2000;
        this.sortDatePrice = 'new';

        this.getDeviceList();

        this.brandService.getBrandSidebar().subscribe(
            (res: Brand) => {
                this.brands = res;
            },
            err => {
                console.log(err);
            }
        );
    }

    getDeviceList() {
        // $('html, body').animate({ scrollTop: 0 }, 'slow');
        let offset = (this.page - 1) * 28;

        this.deviceService
            .getDeviceList(
                offset,
                // this.getBy,
                this.brandName,
                this.type,
                this.minValue,
                this.maxValue,
                this.sortDatePrice
            )
            .subscribe(res => {
                let data = (res as any).data;
                this.metadata = (res as any).metadata;
                this.devices = data;
            });
    }
}
